import { useMatch, useParams } from 'react-router'
import { H4 } from '@/components/sv/typographies'
import { Button } from '@/components/ui/button'
import { CardAction, CardDescription, CardHeader } from '@/components/ui/card'
import { gql } from '@/lib/graphql/gql'
import { useCompanyPath, useIdCompany, useSuspenseQuery } from '@/lib/hooks'
import { ToggleWebhookDialog } from '@/routes/webhook/tabs/overview/sections/danger-zone/toggle-webhook/toggle-webhook-dialog'
import type {
  WebhookToggleQuery,
  WebhookToggleQueryVariables,
} from '@/routes/webhook/tabs/overview/sections/danger-zone/toggle-webhook/index.types.gen'

const WEBHOOK_TOGGLE_QUERY = gql`
  query WebhookToggle($idCompany: String!, $id: String!) {
    company(id: $idCompany) {
      id
      webhook(id: $id) @live {
        id
        isEnabled
      }
    }
  }
`

export const ToggleWebhook = () => {
  const { idWebhook = '' } = useParams()
  const { idCompany } = useIdCompany()
  const { navigateToPath } = useCompanyPath()
  const isDialogOpen = Boolean(useMatch('/webhook/:idWebhook/overview/toggle'))

  const { data } = useSuspenseQuery<
    WebhookToggleQuery,
    WebhookToggleQueryVariables
  >(WEBHOOK_TOGGLE_QUERY, {
    variables: { idCompany, id: idWebhook },
  })
  const webhook = data?.company?.webhook

  return (
    <>
      <CardHeader className="py-6 pb-0">
        <H4>{webhook?.isEnabled ? 'Disable' : 'Enable'} webhook</H4>
        <CardDescription>
          When you {webhook?.isEnabled ? 'Disable' : 'Enable'} a webhook, it
          will{' '}
          {webhook?.isEnabled
            ? 'stop sending events to the endpoint.'
            : 'start sending events to the endpoint.'}
        </CardDescription>
        <CardAction>
          <Button
            variant="outline"
            onClick={() =>
              navigateToPath({
                pathname: '/webhook/:idWebhook/overview/toggle',
                variables: { idWebhook },
                options: { replace: true },
              })
            }
          >
            {webhook?.isEnabled ? 'Disable' : 'Enable'} webhook
          </Button>
        </CardAction>
      </CardHeader>
      <ToggleWebhookDialog
        isEnabled={Boolean(webhook?.isEnabled)}
        isOpen={isDialogOpen}
        onClose={() =>
          navigateToPath({
            pathname: '/webhook/:idWebhook/overview',
            variables: { idWebhook },
            options: { replace: true },
          })
        }
      />
    </>
  )
}
